import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const VariableDialog = ({
  isOpen,
  onClose,
  variable,
  onInputChange,
  onCheckboxChange,
  onSave,
  mode = "add",
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {mode === "add" ? "Add Variable" : "Edit Variable"}
          </DialogTitle>
          <DialogDescription>
            {mode === "add"
              ? "Create a new repository variable"
              : "Update the repository variable"}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="key">Key</Label>
            <Input
              id="key"
              name="key"
              placeholder="VARIABLE_NAME"
              value={variable.key}
              onChange={onInputChange}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="value">Value</Label>
            <Input
              id="value"
              name="value"
              placeholder="Variable value"
              value={variable.value}
              onChange={onInputChange}
            />
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="secured"
              checked={variable.secured}
              onCheckedChange={onCheckboxChange}
            />
            <Label htmlFor="secured">
              Secured variable (hidden in UI and API)
            </Label>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSave}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VariableDialog;
